import sanitizeHtml from 'sanitize-html';

export const sanitizeHtmlTags = (dirtyString: string): string =>
  sanitizeHtml(dirtyString, {
    allowedAttributes: {
      a: ['href'],
    },
    allowedTags: ['b', 'strong', 'i', 'em', 'a', 'br'],
  });
